
import Header from "../components/common/patient/header";
import Sidebar from "../components/common/patient/sidebar";
import { Menu } from "lucide-react";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Button } from "../components/ui/button";

const PatientLayout = () => {
    const [open, setOpen] = useState(true);
    return (
        <>
            <div className="h-screen flex flex-col bg-white overflow-hidden">
                <Header />
                <div className="relative  flex flex-1 overflow-hidden">

                    <div
                        className={`hidden md:block absolute left-0 top-0 h-full w-56 bg-white border-r z-20 transform transition-transform duration-300 ease-in-out ${open ? "translate-x-0" : "-translate-x-full"}`}>
                        <div className="h-full w-full overflow-y-auto">
                            <Sidebar setOpen={setOpen} />
                        </div>
                    </div>

                    {!open && (
                        <div className="p-2 z-10">
                            <Button
                                onClick={() => setOpen(true)}>
                                <Menu className="text-gray-800 solid" />
                            </Button>
                        </div>
                    )}

                    <div className={`flex-1 p-4 overflow-y-auto transition-all duration-300 ease-in-out ${open ? "md:ml-56" : "md:ml-0"}`}>

                        
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );

};
export default PatientLayout